import React from 'react'
import {FormInput, FormPassword, FormSubmit} from '@myxplor/forms'

const Form = ({
  loading,
  submitText = 'Next',
  errors = {},
  handleSubmit,
  handleChange,
  values = {}
}) => (
  <form onSubmit={handleSubmit}>
    <fieldset>
      <FormInput
        required={true}
        name="approval_id"
        label="CCB Approval ID"
        hint="This is your government number"
        onChange={handleChange}
        errors={errors.gov_id}
        loading={loading}
        value={values.approval_id}
      />

      <FormInput
        required={true}
        name="username"
        label="Username"
        hint="Your username with government"
        onChange={handleChange}
        errors={errors.username}
        loading={loading}
        value={values.username}
      />

      <FormPassword
        required={true}
        name="password"
        label="Password"
        hint="Your government password, (not your Xplor password)"
        onChange={handleChange}
        errors={errors.password}
        loading={loading}
        value={values.password}
      />
    </fieldset>

    <FormSubmit
      loading={loading}
      loadingTitle="Retrieving your registration…"
      errors={errors.registration || errors.external_id}
    >
      {submitText}
    </FormSubmit>
  </form>
)

export default Form



// WEBPACK FOOTER //
// ./src/approval-form/views/index.jsx